/**
 * Подписи платёжных провайдеров.
 *
 * Лежали копией в четырёх экранах и успели разойтись: в истории платежей была
 * «Lava», на всех остальных — «Lava (Cards)». Имена брендов не переводятся,
 * локализуются только два не-латинских — СБП и Звёзды.
 */
import i18n from '@/i18n';

const BRAND: Record<string, string> = {
  cryptobot: 'CryptoBot',
  lava: 'Lava (Cards)',
  heleket: 'Heleket',
  lzt: 'LZT Market',
  xrocket: 'xRocket',
};

export function providerLabel(id: string): string {
  if (id === 'platega') return i18n.t('Provider platega');
  if (id === 'aurapay') return i18n.t('Provider aurapay');
  if (id === 'aurapay_card') return i18n.t('Provider aurapay_card');
  if (id === 'antilopay') return i18n.t('Provider antilopay');
  if (id === 'stars') return i18n.t('Provider stars');
  return BRAND[id] ?? id.toUpperCase();
}

/**
 * Назначение операции для истории.
 *
 * Ключей два набора, потому что лента объединённая: у счёта провайдера это `intent`
 * (`subscribe`, `topup`), у движения баланса — `reason` проводки
 * (`subscription_purchase`, `referral_bonus`). Раскладывать их по двум функциям смысла
 * нет: на экране это одна колонка «за что».
 */
export function intentLabel(
  intent: string | null | undefined,
  signed?: number,
  source?: 'payment' | 'wallet',
): string {
  const key: Record<string, string> = {
    // счета провайдеров
    subscribe: 'Intent subscribe',
    gift: 'Intent gift',
    renew: 'Intent renew',
    upgrade: 'Intent upgrade',
    traffic: 'Intent traffic',
    addon: 'Intent addon',
    topup: 'Intent topup',
    // проводки по балансу
    subscription_purchase: 'Intent subscribe',
    subscription_renewal: 'Intent renew',
    subscription_upgrade: 'Intent upgrade',
    traffic_purchase: 'Intent traffic',
    devices_purchase: 'Intent devices',
    referral_bonus: 'Intent referral bonus',
    adjustment: 'Intent adjustment',
    refund: 'Intent refund',
    voucher_redeem: 'Intent voucher',
    giveaway_prize: 'Intent giveaway prize',
    // вывод реферального заработка: сумма уходит в заявку и возвращается при отмене
    // или отказе
    client_withdraw_request: 'Intent withdraw request',
    client_withdraw_return: 'Intent withdraw return',
    // аккаунт сайта влился в этот: баланс переехал одной проводкой
    client_merge: 'Intent account merge',
    client_merge_bonus: 'Intent account merge bonus',
  };
  if (!intent) return i18n.t('Intent unknown');
  const hit = key[intent];
  if (hit) return i18n.t(hit);
  // Новый вид операции, о котором фронт ещё не знает: сырой код («mirror_bonus»)
  // человеку ничего не говорит, а направление денег известно всегда.
  if (source === 'payment') return i18n.t('Intent payment');
  if (signed !== undefined) return i18n.t(signed > 0 ? 'Intent credit' : 'Intent debit');
  return intent;
}

/** Откуда операция: счёт провайдера или внутренний баланс. */
export function sourceLabel(source: string, provider: string): string {
  return source === 'wallet' ? i18n.t('Source balance') : providerLabel(provider);
}
